module.exports = __webpack_public_path__ + "img/dog.6582a524.svg";